export const CategoryPriceLimitAppliedEnum = Object.freeze({
  HIGHEST: 'highest',
  LOWEST: 'lowest',
});
